import gql from 'graphql-tag';

export const GET_CMS_PAGE =
  process.env.__FF_TREADWELL_LANDING_PAGE_CMS__ === 'true'
    ? /* eslint-disable */ gql`
  query CmsPage($id: String!) {
    cms {
      page(id: $id) {
        documentTitle
        metaTags {
          name
          content
        }
        pageAnalytics {
          name
          value
        }
        breadcrumbs {
          name
          url
        }
        htmlContent
        source
      }
    }
  }
`
    : /* eslint-enable */ gql`
query CmsPage($id: String!) {
  cms {
    page(id: $id) {
      documentTitle
      metaTags {
        name
        content
      }
      breadcrumbs {
        name
        url
      }
      htmlContent
      source
    }
  }
}
`;
